<template>
  <div id="dashboard-report">
    <h3>Relatório de Satisfação</h3>
    <span>Aqui você pode extrair uma planilha com o relatório de satisfação, contendo as notas dadas pelos seus clientes</span>
    <!-- <vs-alert
      style="height: fit-content;"
      title="Aviso"
      active="true"
      class="mb-8 mt-8"
      color="warning"
    >
      <span>Essa função de avaliação ainda está em testes, caso ocorra algum problema chame nosso suporte e nos ajude a melhorar seu uso!</span>
    </vs-alert> -->
    <div class="vx-row mt-10">
      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span mr-12">
              Período (de)
            </span>
          </div>

          <div class="w-full">
            <flat-pickr 
              :config="configdateTimePicker"
              v-model="start_at"
              name="Período (de)"
              placeholder="Escolha um dia"
              v-validate="'required'"
            />

            <div class="clear: both;">
              <span
                class="text-danger text-sm"
                v-show="errors.has('Período (de)')"
              >
                {{ errors.first('Período (de)') }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <div class="w-12/12">
          <div class="w-full justify-center items-center">
            <span class="phone-number-span mr-12">
              Período (até)
            </span>
          </div>

          <div class="w-full">
            <flat-pickr 
              :config="finishAtConfig(configdateTimePicker)"
              v-model="finish_at"
              name="Período (até)"
              placeholder="Escolha um dia"
              v-validate="'required'"
              :disabled="start_at === ''"
            />

            <div class="clear: both;">
              <span
                class="text-danger text-sm"
                v-show="errors.has('Período (até)')"
              >
                {{ errors.first('Período (até)') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
      <div class="w-12/12">
        <div class="w-full justify-center items-center">
          <span class="phone-number-span">Tipo de Avaliação</span>
        </div>

        <v-select
          label="name"
          name="nps"
          class="w-full"
          v-model="npsId"
          v-validate="'required'"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          :options="messages"
          :reduce="messages => messages.id"
        />
      </div>

      <div class="clear: both;">
        <span class="text-danger text-sm" v-show="errors.has('nps')">
          É obrigatório inserir o Tipo da Avaliação.
        </span>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="w-12/12">
          <div class="w-full">
            <vs-button class="mt-5" @click="generateSheet">
              Gerar Relatório
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import {Portuguese} from 'flatpickr/dist/l10n/pt.js'

import VxTimeline from "@/components/timeline/VxTimeline"
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import 'flatpickr/dist/flatpickr.css'
import reportHttp from '@/http/requests/report'

import UsersTable from './UsersTable.vue'
import requests from "@/http/requests/messages";

export default {
  data() {
    return {
      configdateTimePicker: {
        enableTime: false,
        noCalendar: false,
        dateFormat: "d/m/Y",
        locale: Portuguese
      },
      types: [
        {
          id: 1,
          label: 'Dados do Operador'
        },
        {
          id: 2,
          label: 'Dados do Atendimento'
        },
      ],
      type: '',
      start_at: '',
      finish_at: '',
      reportUser: 'all',
      selectedUsers: [],
      messages: [],
      npsId: null
    }
  },
  computed: {
    isFormValid() {
      return !this.errors.any()
    }
  },
  watch: {
    reportUser: function (reportUser) {
      if (reportUser === 'all') {
        this.selectedUsers = []
      }
    }
  },
  methods: {
    chooseUser(userId) {
      const index = this.selectedUsers.indexOf(userId)

      if (index === -1) {
        this.selectedUsers.push(userId)
      } else {
        this.selectedUsers.splice(index, 1)
      }
    },
    generateSheet() {
      const startAt = this.datePtToEng(this.start_at)
      const finishAt = this.datePtToEng(this.finish_at)

      window.scrollTo(0, 0);
      this.$validator.validateAll().then(result => {
        if (result) {
          reportHttp.npsReport(startAt, finishAt, this.npsId).then(res => {
            const {chatTicketsReport} = res.data.data
            this.downloadXlsx(chatTicketsReport)
          }).catch(err => {
            console.error(err)
          })
        } else {
          window.scrollTo(0, 0);
        }
      })
    },
    downloadXlsx(url) {
      let reportName = 'Relatório'
      reportName += 'Relatório de Satisfação - '
      reportName += ` ${this.datePtToEng(this.start_at)} até ${this.datePtToEng(this.finish_at)}`

      axios.get(url, { responseType: 'blob'} ).then(res => {
        const blob = new Blob(
          [res.data],
          {
            type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8;`
          }
        )

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `${reportName}.xlsx`
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    },
    fetchMessages() {
      this.messages = [];
      requests.fetch({ tag: 'nps_message', from_mutation: true })
        .then((response) => { this.messages = response.data.data.messages; })
        .catch((error) => { console.error(error) })
    },
    datePtToEng(date) {
      date = date.split('/')
      return `${date[2]}-${date[1]}-${date[0]}`
    },
    finishAtConfig(config) {
      return {
        ...config,
        minDate: this.start_at
      }
    }
  },
  mounted() {
    this.fetchMessages()
  },
  components: {
    ChangeTimeDurationDropdown,
    VxTimeline,
    flatPickr,
    vSelect,
    UsersTable
  }
}
</script>

<style lang="scss">
.v-select {
  background: #fff;
}

/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
